import React, { useContext, Fragment } from 'react';
import useSectionStyles from './styles';
import PageContext from '../../contexts/pageContext';
import Carousel from '../../components/carousel';
import Button from '../../components/button';
import NextImageRenderer from '../../components/nextImageRenderer';
import { wordBreakValue } from '../../utils/cssUtils';
function Section({ nodeData, sectionIndex, extraProps }) {
  const {
    layout: { containerWidth },
    isMobile,
    isCustomWebsite,
    countryCode
  } = useContext(PageContext);
  const classes = useSectionStyles({
    isCustomWebsite,
    isMobile,
    wordBreakValue: wordBreakValue(countryCode)
  });

  const handleButton = () => {
    extraProps?.courseBuyNow();
  };

  return (
    <div className={classes.centerData}>
      <div className={classes.partialBackground} />
      <div className={classes.contentContainer}>
        <div className={classes.textContainer}>
          <div className={classes.subTitleHeading}>
            <span
              ref={nodeData?.cardHeading?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData.cardHeading.metadata.value
              }}
            />
          </div>
          <h2 className={classes.heading}>
            <span
              ref={nodeData?.title?.refSetter}
              dangerouslySetInnerHTML={{
                __html: nodeData.title.metadata.value
              }}
            />
          </h2>

          <p
            ref={nodeData?.description?.refSetter}
            className={classes.description}
            dangerouslySetInnerHTML={{
              __html: nodeData.description.metadata.value
            }}
          />
          {nodeData?.cta?.validations?.isEmptyAllowed &&
          nodeData?.cta?.metadata?.value === '' ? null : nodeData?.cta?.metadata
              ?.default === true ? (
            <Button
              data={nodeData.cta.metadata}
              ref={nodeData?.cta?.refSetter}
              type={nodeData?.cta?.metadata?.type}
              size={isMobile ? 'small' : 'medium'}
              onClick={handleButton}
            />
          ) : (
            <Button
              ref={nodeData?.cta?.refSetter}
              data={nodeData.cta.metadata}
              type={nodeData?.cta?.metadata?.type}
              size={isMobile ? 'small' : 'medium'}
            />
          )}
        </div>
        <div className={classes?.imageContainer}>
          {/* <img
          ref={nodeData?.image?.refSetter}
          className={classes.sideBannerImage}
          src={nodeData.image.metadata.value}
        /> */}
          <NextImageRenderer
            ref={nodeData?.image?.refSetter}
            className={classes.sideBannerImage}
            src={nodeData.image.metadata.value}
            sectionIndex={sectionIndex}
          />
        </div>
      </div>
    </div>
  );
}

export default function BannerCarouselRight({
  sectionData,
  sectionIndex,
  extraProps
}) {
  const {
    isMobile,
    layout: { containerWidth }
  } = useContext(PageContext);
  const classes = useSectionStyles({ containerWidth, isMobile });
  const [{ bannerCarousel }] = sectionData.components;
  const Wrapper = bannerCarousel.components.length > 1 ? Carousel : Fragment;
  const wrapperProps =
    bannerCarousel.components.length > 1
      ? {
          buttonContainerClass: classes.absoluteButtonsBannerRight,
          inverted: false
        }
      : {};
  return (
    <section className={classes.bannerCarouselRightSection}>
      <div className={classes.sectionContainer}>
        <Wrapper {...wrapperProps}>
          {bannerCarousel.components.map((node, idx) => (
            <Section
              nodeData={node}
              key={idx /* or some other unique property */}
              sectionIndex={sectionIndex}
              extraProps={extraProps}
            />
          ))}
        </Wrapper>
      </div>
    </section>
  );
}
